import { render, staticRenderFns } from "./BagMaterialEdit.vue?vue&type=template&id=1a2f53a7&"
import script from "./BagMaterialEdit.vue?vue&type=script&lang=js&"
export * from "./BagMaterialEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports